<template>
    <div v-if="haveData">
        <h3>Transition Risk</h3>
        <br>
        <carbon-table  v-for="metric in metrics" :metric="metric"/>
    </div>
  </template>
  <script>
  import { mapState } from 'vuex'
  import { basicTransitionMetrics, hasData } from '@/utils/climate'
  import CarbonTable from '@/components/CarbonTable.vue'

  export default {
    components: {CarbonTable},
    computed: {
      ...mapState({
        summaryData: state => state.summaryData
      }),
      metrics() {
        return this.allMetrics.filter(this.hasData)
      },
      allMetrics() {
        return basicTransitionMetrics
      },
      haveData() {
        return this.metrics.length > 0
      }
    },
    methods: {
        hasData(metric) {
            return hasData(metric, this.summaryData)
        }
    }
  }
  </script>

  <style scoped>
  
  h3 {
    color: rgba(0, 0, 0, 0.6);
  }

  </style>
